<template>
  <!--
    作者：kmdshop
    时间：2020-06-04
    描述：插件中心-积分商城-兑换设置
  -->
  <div class="user">
    <div class="common-form d-s-c"><span>设置</span></div>
    <div class="p20">
      <el-form ref="form" size="small" label-width="160px">
        <el-form-item label="是否开启报单积分" prop="status"><el-switch v-model="form.status"></el-switch></el-form-item>
   
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import LooprebateApi from '@/api/looprebate.js';
export default {
  data() {
    return {
      form: {
        /*是否开启循环返利*/
        status: false,
      },
      loading: false
    };
  },
  created() {
    /*获取数据*/
    this.getData();
  },
  methods: {
    /*获取数据*/
    getData() {
      let self = this;
      LooprebateApi.getSetting({}, true)
        .then(data => {
          self.form = data.data;
        })
        .catch(error => {});
    },

    /*提交保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      LooprebateApi.setting(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/plus/looprebate/setting.vue